<template>
  <div>
  <div class="newhead">
          <div class="pictrue1"><img src="../../assets/images/defaultavatar1.png" /></div>
  </div>
  <div class="nickname">奥鲲会员</div>
  <div class="memberjf"><img src="../../assets/images/jifen.png" />{{ userInfo.integral || 0 }}</div>
    <div class="exchange">
        <input type="text" placeholder="请输入兑换码" v-model="exchangeNum" />
        <div class="exchange-btn" @click="exchange">兑换</div>
      </div>
      <div class="list" @scroll="onListScroll" ref="listContainer">
        <div class="list-title">积分明细</div>
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in integralList"
          :key="index"
        >
          <div>
            <div class="state">{{ item.title }}</div>
            <div class="time">{{ item.updateTime }}</div>
          </div>
          <div class="num" v-if="item.type == 1">+{{ item.integral }}</div>
          <div class="num font-color-red" v-if="item.type == 2">
            -{{ item.integral }}
          </div>
        </div>
        <div class="loading-tip" v-if="loading">加载中...</div>
        <div class="loading-tip" v-if="loaded && integralList.length > 0">没有更多了</div>
        <div class="empty" v-if="!loading && integralList.length === 0">
          暂无积分
        </div>
      </div>
  <div class="user">

    <div class="header acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">

        <div class="text">
          <div class="acea-row row-middle">


          </div>


        </div>
      </div>
    </div>
    <div class="wrapper">

      <!-- 我的订单 - 暂时隐藏
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>
      -->
      <!-- 我的服务 - 暂时隐藏
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
        </div>
      </div>
      -->
    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
  </div>
</template>

<script>
import {
  getUser,
  getMenuUser,
  getIntegralList,
  getUserIntegral,
} from "@api/user";
import { verifyTraceabilityCode } from "@api/code";
import { isWeixin } from "@utils";
import cookie from "@utils/store/cookie";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow,
  },
  props: {},
  data: function () {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: "",
      },
      exchangeNum: "",
      integralList: [],
      integralWhere: {
        page: 1,
        limit: 15,
      },
      loaded: false,
      loading: false,
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    },
  },
  mounted: function () {
    this.User();
    this.MenuUser();
    this.getIntegralData();
    this.getIntegralListData();
    this.isWeixin = isWeixin();
    // 登录成功后，自动回填溯源码到兑换框
    const traceabilityCode = cookie.get("traceability_code");
    if (traceabilityCode) {
      this.exchangeNum = traceabilityCode;
      cookie.remove("traceability_code");
    }
  },
  methods: {
    changeswitch: function (data) {
      this.switchActive = data;
    },
    User: function () {
      let that = this;
      getUser().then((res) => {
        const data = res.data || res;
        // 字段映射：API 字段名 → 模板字段名
        that.userInfo = {
          ...data,
          uid: data.id,
          vip: data.isVip,
          vip_icon: data.vipIcon,
          vip_name: data.vipName,
          now_money: data.nowMoney || 0,
          is_promoter: data.isPromoter || 0,
          brokerage_price: data.brokeragePrice || 0,
          promoter_price: data.promoterPrice || 0,
          login_type: data.loginType || "",
          statu: data.statu || 0,
        };
        that.orderStatusNum = data.orderStatusNum || {};
        this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${
            data.promoterPrice || 0
          }元</span>即可开通推广权限`,
          title: "您未获得推广权限",
        };
      });
    },
    MenuUser: function () {
      let that = this;
      getMenuUser().then((res) => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    exchange: function () {
      if (!this.exchangeNum || this.exchangeNum.length === 0) {
        return this.$dialog.error("请输入兑换码");
      }
      this.$dialog.loading.open("处理中...");
      verifyTraceabilityCode(this.exchangeNum)
        .then((res) => {
          this.$dialog.loading.close();
          this.$dialog.success(res.message || "核销成功");
          this.exchangeNum = "";
          // 清除cookie中的兑换码
          cookie.remove("traceability_code");
          // 刷新积分数据
          this.integralWhere.page = 1;
          this.loaded = false;
          this.loading = false;
          this.integralList = [];
          this.getIntegralData();
          this.getIntegralListData();
        })
        .catch((err) => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "核销失败");
        });
    },
    getIntegralData: function () {
      getUserIntegral().then((res) => {
        this.$set(this.userInfo, "integral", res.data.integral);
      });
    },
    getIntegralListData: function () {
      if (this.loaded == true || this.loading == true) return;
      this.loading = true;
      getIntegralList(this.integralWhere).then(
        (res) => {
          this.loading = false;
          var list = res.data.list || [];
          this.loaded = list.length < this.integralWhere.limit;
          this.integralWhere.page = this.integralWhere.page + 1;
          this.integralList.push.apply(this.integralList, list);
        },
        (err) => {
          this.loading = false;
          this.$dialog.message(err.msg);
        }
      );
    },
    onListScroll: function (e) {
      const container = e.target;
      // 判断是否滚动到底部（距离底部 50px 时触发加载）
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 50
      ) {
        this.getIntegralListData();
      }
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPages: function (index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },
  },
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.user .header:after {
  background-color: transparent;
}

.newhead {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 99px;

    opacity: 1;
}
.pictrue1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 3.75px;
  width: 118.21px;
  height: 119.16px;
  opacity: 1;
}
.pictrue1 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.nickname {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 251px;
  width: 214px;
  height: 31px;
  opacity: 1;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 35.16px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  vertical-align: top;
}
.memberjf {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 290px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 18.75px;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
  white-space: nowrap;
}
.memberjf img {
  width: 17.65px;
  height: 17.65px;
  margin-right: 4px;
  display: block;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
.exchange {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 321px;
  width: 360px;
  height: 40px;
  opacity: 1;
  border-radius: 8px;
  border: 2px solid rgba(94, 94, 94, 1);
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: transparent;
  box-sizing: border-box;
}
.exchange input {
  height: 36px;
  flex: 1;
  border: none;
  font-size: 14px;
  outline: none;
  opacity: 1;
  border-radius: 8px;
  background: transparent;
  color: rgba(44, 44, 44, 1);
}
.exchange input:focus {
  border-color: #e93323;
}
.exchange-btn {
  position: absolute;
  left: 310px;
  top: 40%;
  transform: translateY(-50%);
  width: 37px;
  height: 12.36px;
  opacity: 1;
  font-size: calc(14 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 21.1px;
  color: rgba(0, 0, 0, 1);
  text-align: right;
  vertical-align: top;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}
.list {
  position: absolute;
  top: 373px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  max-height: 340px;
  overflow-y: auto;
  background: #fff;
  padding: 15px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  z-index: 10;
}
/* 隐藏滚动条 */
.list::-webkit-scrollbar {
  display: none;
}
.list {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.loading-tip {
  text-align: center;
  padding: 10px 0;
  font-size: 12px;
  color: #999;
}
.list-title {
  font-size: 14px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  background: rgba(255, 255, 255, 1);
}
.list .item {
  padding: 2px 0;
  border-bottom: 1px solid #f5f5f5;
}
.list .item:last-child {
  border-bottom: none;
}
.list .state {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}
.list .time {
  font-size: 12px;
  color: rgba(128, 128, 128, 1);
}
.list .num {
  font-size: 16px;
  font-weight: bold;
  color: #33c334;
}
.list .empty {
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
  color: #999;
}
.font-color-red {
  color: #e54d42 !important;
}
</style>
